import clientServerBridge from '@helpcenter/client-server-bridge';
import { getMeta } from '@helpcenter/meta';

// Extracted from module @atlassiansox/analytics-web-client
// TypeScript upgrade (v4.4.3). Please correct when you revisit this code.

export enum EnvType {
	LOCAL = 'local',
	DEV = 'dev',
	STAGING = 'staging',
	PROD = 'prod',
}

export interface Env {
	environment: EnvType;
	featureFlags: {
		[key: string]: boolean;
	};
	wacLink: string;
	contactLink: string;
	headless: boolean;
	serviceDeskVersion: string;
	contextPath: string;
	xsrfToken: string;
	baseUrl: string;
	relativeBaseUrl: string;
	anonymousEnabled: boolean;
	requestIntroEnabled: boolean;
	mediaApiExternalUrl?: string;
	mediaApiAppClientId?: string;
	fabricEmojiUrl?: string;
	jiraDisplayUrl: string;
	helpCenterHomePageSlug: string;
	helpCenterType: string;
	traceId?: string;
	featuredValues?: {
		[key: string]: boolean;
	};
	siteDefaultLanguageTag: string;
	hoistedProjectKey?: string;
	hoistedProjectId?: number;
	hoistedPortalId?: number;
	customerAccountAvailabilty?: string;
	edition?: string;
}

function parseEnvironment() {
	const env = getMeta('environment');
	if (env === 'prod') {
		return EnvType.PROD;
	}
	if (env === 'staging') {
		return EnvType.STAGING;
	}
	return EnvType.DEV;
}

// Suppressing existing violation. Please fix this.
// eslint-disable-next-line @typescript-eslint/no-unsafe-return
const parseJson = (content?: string | null) => (content ? JSON.parse(content) : {});

const envElement = clientServerBridge.getElementById('envJson');

let envData: Env;

export const getEnv = () => {
	if (envData) {
		return envData;
	}

	// Suppressing existing violation. Please fix this.
	// eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
	envData = Object.freeze({
		...parseJson(envElement && envElement.textContent),
		environment: parseEnvironment(),
	});

	return envData;
};

export const getIsPageServerSideRendered = () => {
	// @ts-ignore - TS2339: Property '__IS_PAGE_SERVER_SIDE_RENDERED__' does not exist on type 'Window & typeof globalThis'.
	// This was added when adding project references to help center.
	return window.__IS_PAGE_SERVER_SIDE_RENDERED__;
};

export const getIsMultiHCEnabled = () => {
	return getEnv().featuredValues?.multiHelpCenterEnabled;
};

export const getIsHCCustomizationEnabled = () => {
	return getEnv().featuredValues?.helpCenterCustomizationEnabled;
};

export const getJsmAIConfigEnabled: () => boolean = () =>
	getEnv().featuredValues?.jsmAiConfigEnabled ?? false;

export const getJiraDisplayUrl = () => {
	return getEnv().jiraDisplayUrl;
};

export const getHoistedProjectKey = () => {
	return getEnv().hoistedProjectKey;
};

export const getRelativeBaseUrl = () => {
	return getEnv().relativeBaseUrl;
};
